module.exports = __webpack_public_path__ + "media/images/assignment/delete-19a384f6826935b8033320548a3d1fee.svg";